import React, { createContext, useContext, useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { translations } from "../translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem("languagePreference");
    return stored || "en";
  });

  useEffect(() => {
    const loadLanguageFromFirestore = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            // Check for languagePreference (user side) or language (admin/staff side)
            const userLang = userDoc.data().languagePreference || userDoc.data().language;
            if (userLang) {
              const firestoreLang = userLang;
              setLanguage(firestoreLang === "Tagalog" || firestoreLang === "Filipino" ? "tl" : "en");
              localStorage.setItem("languagePreference", firestoreLang === "Tagalog" || firestoreLang === "Filipino" ? "tl" : "en");
            }
          }
        } catch (error) {
          console.error("Error loading language preference from Firestore:", error);
        }
      }
    };
    loadLanguageFromFirestore();
  }, []);

  const changeLanguage = async (newLang) => {
    setLanguage(newLang);
    localStorage.setItem("languagePreference", newLang);

    const user = auth.currentUser;
    if (user) {
      try {
        await updateDoc(doc(db, "users", user.uid), {
          languagePreference: newLang === "tl" ? "Tagalog" : "English",
          updatedAt: serverTimestamp(),
        });
      } catch (error) {
        console.error("Error updating language preference in Firestore:", error);
      }
    }
  };

  const getTranslations = (isAdmin = false, isContentCurator = false, isPeerEducator = false, isMedicalProfessional = false) => {
    if (isAdmin) {
      return language === "tl" ? translations.adminTl : translations.admin;
    }
    if (isContentCurator) {
      return language === "tl" ? translations.contentCurator : translations.contentCuratorEn;
    }
    if (isPeerEducator) {
      return language === "tl" ? translations.peerEducatorTl : translations.peerEducatorEn;
    }
    if (isMedicalProfessional) {
      return language === "tl" ? translations.medicalProfessionalTl : translations.medicalProfessionalEn;
    }
    return language === "tl" ? translations.tl : translations.en;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, getTranslations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
